
export class ProductoPrecio {
    id: number;
    idProducto: number;
    idEmisor: number;
    idUnidad: number;
    precioVenta: number;
    descripcion:string;
    }

    